import { render, staticRenderFns } from "./PopWindow.vue?vue&type=template&id=cc4becbe&scoped=true&"
import script from "./PopWindow.vue?vue&type=script&lang=js&"
export * from "./PopWindow.vue?vue&type=script&lang=js&"
import style0 from "./PopWindow.vue?vue&type=style&index=0&id=cc4becbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4becbe",
  null
  
)

export default component.exports